export default __webpack_public_path__ + "static/media/SLIDE_PARRA_9.aaf120b6.jpg";